import { ReactNode } from 'react'
import MdButton from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import { theme } from 'src/providers/ThemeProvider'

const styles = {
  color: theme.colors.gray02,
  borderColor: theme.colors.gray02,
  '&:hover': {
    backgroundColor: theme.colors.gray02,
    borderColor: theme.colors.gray02
  },
  '&:focus-visible': {
    borderColor: theme.colors.gray02
  }
}

type Props = {
  children: ReactNode
  disabled?: boolean
  onClick: () => void
  loading?: boolean
}

export default function ButtonSecondaryOutlined({
  children,
  loading,
  ...rest
}: Props): JSX.Element {
  return (
    <MdButton
      {...rest}
      variant="outlined"
      sx={styles}
      startIcon={loading ? <CircularProgress size={18} /> : null}
    >
      {children}
    </MdButton>
  )
}
